/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { createSlice } from "@reduxjs/toolkit";
import { clearBrowserSession } from "../../Utils/sessionCleanup";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isSignedIn: false,
    userStatus: null,
    isLoginDialogOpen: false,
    isRegisterDialogOpen: false,
    UserPageOpen: false,
    deletePageOpen: false,
    status: null,
    selectedUser: null,
  },

  reducers: {
    login: (state, action) => {
      const { access_token, details } = action.payload;
      sessionStorage.setItem("access_token", access_token);
      sessionStorage.setItem("isSignedIn", 1);
      Object.assign(state, {
        isSignedIn: true,
        isLoginDialogOpen: false,
        details,
      });
    },
    logout: (state) => {
      // Clears sessionStorage wholesale plus the persisted floor / delivery /
      // invoice state, so nothing from this session survives into the next one.
      // Listing keys by hand meant every key added later was silently kept.
      clearBrowserSession();

      Object.assign(state, {
        isSignedIn: false,
        userStatus: null,
        isLoginDialogOpen: false,
        isRegisterDialogOpen: false,
        UserPageOpen: false,
        deletePageOpen: false,
        status: null,
        selectedUser: null,
      });
      delete state.details;
    },
    toggleLoginDialog: (state) => {
      state.isLoginDialogOpen = !state.isLoginDialogOpen;
    },
    toggleRegisterDialog: (state) => {
      state.isRegisterDialogOpen = !state.isRegisterDialogOpen;
    },
  },
});

export const { login, logout, toggleLoginDialog, toggleRegisterDialog } =
  authSlice.actions;

export default authSlice.reducer;
